import type { WishItem } from "../../models/contracts";
import { WishCard } from "./WishCard";

export const MosaicWishRenderer = ({ wishes, focusId }: { wishes: WishItem[]; focusId: string | null }) => (
  <div class="wish-layout wish-layout-mosaic">{wishes.map((wish, index) => <WishCard key={wish.id} wish={wish} index={index} focusId={focusId} />)}</div>
);
